import React, { useState } from 'react';
import '../../style/linkPage.css'

const LinksPractice = () => {
  // State to store the current API response message
  const [apiResponse, setApiResponse] = useState(null);

  // Helper to update the output section
  const handleApiClick = (status, text) => {
    setApiResponse({ status, text });
  };

  return (
    <div className="links-page-container">
      <h1>Links</h1>
      
      <h5 className="text-left"><strong>Following links will open new tab</strong></h5>
       <p className="text-left"><a href="/" target="_blank" rel="noreferrer">Home</a></p>
      <p className="text-left"><a href="https://www.google.com" target="_blank" rel="noreferrer">HomewPWPU</a></p>
     
      
      <h5 className="text-left"><strong>Following links will send an api call</strong></h5>
      
      {/* API Links */}
      <p className="text-left"><button type="button" className="link-button" onClick={() => handleApiClick(200, "Success")}>OK</button></p>
      <p className="text-left"><button type="button" className="link-button" onClick={() => handleApiClick(201, "Created")}>Created</button></p>
      <p className="text-left"><button type="button" className="link-button" onClick={() => handleApiClick(204, "No Content")}>No Content</button></p>
      <p className="text-left"><button type="button" className="link-button" onClick={() => handleApiClick(301, "Moved Permanently")}>Moved</button></p>
      <p className="text-left"><button type="button" className="link-button" onClick={() => handleApiClick(400, "Bad Request")}>Bad Request</button></p>
      <p className="text-left"><button type="button" className="link-button" onClick={() => handleApiClick(401, "Unauthorized")}>Unauthorized</button></p>
      <p className="text-left"><button type="button" className="link-button" onClick={() => handleApiClick(403, "Forbidden")}>Forbidden</button></p>
      <p className="text-left"><button type="button" className="link-button" onClick={() => handleApiClick(404, "Not Found")}>Not Found</button></p>
      
      {/* THE OUTPUT SECTION */}
      {apiResponse && (
        <div className="api-response-output">
          Link has responded with status <b>{apiResponse.status}</b> and status text <b>{apiResponse.text}</b>
        </div>
      )}
    </div>
  );
};

export default LinksPractice;
